import React from 'react'

const Table = ({ children }) => {
    return (
        <div className="table-responsive">
            <table className="table table-striped">{children}</table>
        </div>

    )
}

export default Table
